import * as React from 'react';

const SvgIconErrorCircle = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="89" height="88" viewBox="0 0 89 88" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M58.0689 60.2774L29.1786 31.387L31.887 28.6786L60.7774 57.5689L58.0689 60.2774Z" fill="#EB0A1E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.8877 60.2774L60.7781 31.387L58.0696 28.6786L29.1792 57.5689L31.8877 60.2774Z" fill="#EB0A1E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M44.5 75.9196C62.1287 75.9196 76.4196 61.6287 76.4196 44C76.4196 26.3713 62.1287 12.0804 44.5 12.0804C26.8713 12.0804 12.5804 26.3713 12.5804 44C12.5804 61.6287 26.8713 75.9196 44.5 75.9196ZM44.5 79.75C64.2442 79.75 80.25 63.7442 80.25 44C80.25 24.2558 64.2442 8.25 44.5 8.25C24.7558 8.25 8.75 24.2558 8.75 44C8.75 63.7442 24.7558 79.75 44.5 79.75Z" fill="#EB0A1E"/>
</svg>
);

export default SvgIconErrorCircle;

